export default {
  getReportExpenseLineItem: (state) => state.reportExpenseLineItem,
};
